import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
class AssetCategoryAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AssetCategory";

  /**
   * Lấy dữ liệu danh sách full
   */
  getAllAssetCategory(payload) {
    let request = {
      url: this.getAPIUrl() + "/asset-category-full",
    };

    return httpClient.getAsync(request);
  }

  /*
   * Lấy nhóm tài sản theo loại tài sản.
   * pvduy 19/04/2021
   * @param {*} assetTypeID
   * @returns
   */
  GetAssetCategoryByAssetTypeID(assetTypeID) {
    let request = {
      url: [this.getAPIUrl(), "asset-category-by-asset-type-id", assetTypeID].join("/"),
    };
    return httpClient.getAsync(request);
  }
}

export default new AssetCategoryAPI();
